// Work intelligence levels. Must stay in sync with
// backend/utils/work_thinking_power.js. These do not pick the organizer —
// they tell it which cheaper / costlier specialist slugs to use for text
// work and subagents.

export const WORK_THINKING_LEVELS = [
  { id: 'fast', index: 0, label: 'Fast' },
  { id: 'standard', index: 1, label: 'Standard' },
  { id: 'high', index: 2, label: 'High' },
];

export const DEFAULT_WORK_THINKING_POWER = 'standard';
export const WORK_THINKING_TRACK_COLOR = '#22c55e';

const LEGACY_LEVEL_ALIASES = {
  'very-high': 'high',
  'extra-high': 'high',
};

function normalizeLevel(id) {
  const key = String(id || '').trim().toLowerCase();
  const aliased = LEGACY_LEVEL_ALIASES[key] || key;
  return WORK_THINKING_LEVELS.some((level) => level.id === aliased)
    ? aliased
    : DEFAULT_WORK_THINKING_POWER;
}

export function thinkingPowerById(id) {
  const key = normalizeLevel(id);
  return WORK_THINKING_LEVELS.find((level) => level.id === key) || WORK_THINKING_LEVELS[0];
}

export function clampThinkingIndex(index) {
  const max = WORK_THINKING_LEVELS.length - 1;
  const n = Number(index);
  if (!Number.isFinite(n)) return thinkingPowerById(DEFAULT_WORK_THINKING_POWER).index;
  return Math.min(max, Math.max(0, Math.round(n)));
}
